module.exports = __webpack_public_path__ + "static/testi4-3bdf97cb07c1d55060a0bf98daa9786b.jpg";